// REQUIRED ----> Vue Setup: Do not edit
import Vue from 'vue'
import Store from './store'
import './directives'
// // ____________________________________________________________________________________________

import _ from 'lodash'
import { TimelineMax } from 'gsap'
// import ScrollMagic from 'scrollmagic'
// import ScrollToPlugin from './vendor/ScrollToPlugin'
import { mapGetters } from 'vuex'

// // Features (as components): Page parts instances
import Panel from './components/panel'
import PanelNav from './components/panelnav'
import NewsGrid from './components/newsgrid'
import NewsTile from './components/newstile'
import MorphBubble from './components/morphbubble'
import Splash from './components/splash'

const bubbletemplate = '#template__morphbubble'
const bubbletemplatelarge = '#template__morphbubble__large'

let store = Store(Vue)
let timelinemaster = new TimelineMax({paused: true})

// // Global Components : To be accessible by all Vue components and instances
Vue.component('newstile', new NewsTile())

Vue.component('splash', new Splash())
// // Bind Vue to page element
window.App = new Vue({
  store: store,
  el: '#vueapp',
  data: () => ({
    scrollcontroller: null,
    cansplash: false
  }),
  components: {
    // // Page parts instances
    'panel': new Panel({
      components: {
        'newsgrid': new NewsGrid(),
        'morphbubble': new MorphBubble(bubbletemplate, timelinemaster),
        'morphbubblelarge': new MorphBubble(bubbletemplatelarge, timelinemaster)
      }
    }),
    'panelnav': new PanelNav()
  },
  mounted () {
    // Populate the news feed
    //this.$store.dispatch('newsfeed/fetch')

    document.onkeydown = (evt) => this.onkeypress(evt)

    if (this.cansplash && this.$refs.splash) {
      this.startSplash()
    } else {
      this.endSplash()
    }
    this.$store.dispatch('panels/initialize').then(() => {})
  },
  computed: {
    pageready () {
      const splashcomplete = (this.cansplash) ? this.splashcomplete : true
      return (this.pageinitialized && splashcomplete)
    },
    islighttheme () {
      return (this.mobile) || (this.logotheme != "" ? this.logotheme !== 'dark' : this.pagetheme !== 'dark')
    },
    islightnav () {
      return (this.mobile) || (this.navtheme !== 'dark')
    },
    scrollposition () {
      return this.scrollprogress.progress
    },
    ...mapGetters({
      mobile: 'viewport/mobile',
      viewwidth: 'viewport/width',

      sidebaractive: 'sidebar/active',
      searchbaractive: 'sidebar/searchactive',
      languagesactive: 'sidebar/languagesactive',

      sidebaranimating: 'sidebar/animating',
      searchbaranimating: 'sidebar/searchanimating',      
      languagesanimating: 'sidebar/languagesanimating',

      splashactive: 'splash/active',
      splashcomplete: 'splash/complete',

      // panelpause: 'panels/pause',
      panelfirstactive: 'panels/isfirstactive',
      panellastactive: 'panels/islastactive',

      scrollprogress: 'viewport/progress',
      pageinitialized: 'panels/initialized',
      // scrolltocomplete: 'panels/scrolltocomplete',
      pageanimating: 'panels/animating',

      pagetheme: 'panels/paneltheme',
      navtheme: 'panels/navtheme',
      logotheme: 'panels/logotheme'
    })
  },
  methods: {
    startSplash () {
      this.$store.dispatch('splash/start')
    },
    endSplash () {
      this.$store.dispatch('panels/initialize').then(() => {
        timelinemaster.play()
      })
      this.$store.dispatch('splash/end').then(() => {
      })
    },
    toggleSidebar: function () {
      if (this.languagesactive || this.searchbaractive) {
        this.closeSidebar()
      }
      this.$store.dispatch('sidebar/toggle')
      this.setFocusBlur()
    },
    toggleSearch: function () {
      if (this.sidebaractive || this.languagesactive) {
        this.closeSidebar()
      }
      this.$store.dispatch('sidebar/toggleSearch')
      this.setFocusBlur()
    },
    toggleLanguages: function () {
      if (this.sidebaractive || this.searchbaractive) {
        this.closeSidebar()
      }      
      this.$store.dispatch('sidebar/toggleLanguages')
      this.setFocusBlur()
    },
    closeSidebar: function () {
      this.$store.dispatch('sidebar/toggle', false)
      this.$store.dispatch('sidebar/toggleSearch', false)
      this.$store.dispatch('sidebar/toggleLanguages', false)
      this.setFocusBlur()
    },
    setFocusBlur: function () {
      if (this.sidebaractive && this.$refs.menu) {
        this.$refs.menu.focus()
      } else if (this.$refs.menu) {
        this.$refs.menu.blur()
      }
      if (this.searchbaractive && this.$refs.search) {
        this.$refs.search.focus()
      } else if (this.$refs.search) {
        this.$refs.search.blur()
      }
      if (this.languagesactive && this.$refs.languages) {
        this.$refs.languages.focus()
      } else if (this.$refs.languages) {
        this.$refs.languages.blur()
      }      
    },
    getElementOffset: function (element) {
      if (!element) return {}
      var de = document.documentElement
      var box = element.getBoundingClientRect()
      var top = box.top + window.pageYOffset - de.clientTop
      var left = box.left + window.pageXOffset - de.clientLeft
      return { top: top, left: left }
    },
    getElPosition: function (el) {
      let position = {
        left: 0,
        top: 0
      }
      if (!el) return position
      position.left = (el.offsetLeft - el.scrollLeft + el.clientLeft)
      position.top = (el.offsetTop - el.scrollTop + el.clientTop)
      return position
    },
    onkeypress (evt) {
      evt = evt || window.event
      if (evt.keyCode === 27) this.closeSidebar()
    },
    speed: function (newY) {
      const rate = 2
      const ppr = 60 // pixels per rate
      const winY = this.scrollposition

      const distance = (newY > winY) ? ((newY - winY)) : ((winY - newY))
      const velocity = (rate / ppr) / 150
      const speed = this.round(distance * velocity)
      return speed
    },
    round: function (v, d) {
      d = (_.isNil(d)) ? 2 : d
      return Number(Math.round(v + 'e' + d) + 'e-' + d)
    }
  }
})



// WEBPACK FOOTER //
// ./assets/js/main.js